import React, { memo } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Avatar, IconButton, styled } from '@mui/material'
import { BackIcon } from './Icons'
import { SurfaceAvatarProps } from './SurfaceAvatar.types'

const StyledAvatar = styled(Avatar)(({ theme }) => ({
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
    },
}))

function SurfaceAvatar({ icon, backButton }: SurfaceAvatarProps) {
    const history = useHistory()

    if (backButton) {
        if (backButton.to) {
            return (
                <IconButton size="medium" component={Link} to={backButton.to}>
                    <BackIcon />
                </IconButton>
            )
        }

        return (
            <IconButton size="medium" onClick={history.goBack}>
                <BackIcon />
            </IconButton>
        )
    }

    return <StyledAvatar variant="circular">{icon}</StyledAvatar>
}

export default memo(SurfaceAvatar)
